import React from 'react';
import './InquiryForm.css';

const InquiryForm = () => {
  return (
    <div className="form-section">
      <div className="form-image">
        <img
          src="/footerimg.webp"
          alt="Students"
        />
      </div>
      <div className="form-container">
        <h2>Join Our Digital Marketing Course</h2>
        <form>
          <input type="text" name="name" placeholder="Full Name" required />
          <input type="email" name="email" placeholder="Email Address" required />
          <input type="tel" name="phone" placeholder="Phone Number" required />
          <input type="text" name="place" placeholder="Your City/Location" required />

          <select name="profession" required>
            <option value="">Select Your Profession</option>
            <option value="student">Student</option>
            <option value="business">Business Person</option>
            <option value="freelancer">Freelancer</option>
            <option value="college-student">College Student</option>
            <option value="other">Other</option>
          </select>

          <textarea
            name="reason"
            rows="4"
            placeholder="Why do you want to learn Digital Marketing?"
            required
          ></textarea>

          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default InquiryForm;
